import $api from "@http";

export default class SessionsService {
  static async getScenarioSessions({page, size, search, sort}) {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);

    if (search) {
      const levelTypes = ["easy", "medium", "hard"];
      const stateTypes = ["created", "started", "ended", "finished"];
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (dateRegex.test(search.trim())) {
        params.append("q[created_at_gteq]", search.trim());
      } else if (levelTypes.includes(search)) {
        params.append("q[level_eq]", search);
      } else if (stateTypes.includes(search)) {
        params.append("q[state_eq]", search);
      } else {
        params.append(
          "q[scenario_name_or_ai_session_title_or_user_name_or_user_lastname_or_scenario_products_name_or_short_feedback_cont]",
          search,
        );
      }
    }

    if (sort?.value === "user") {
      params.append("q[s][]", `user_lastname ${sort.direction || "asc"}`);
      params.append("q[s][]", `user_name ${sort.direction || "asc"}`);
    } else if (
      sort?.value.toLowerCase() === "scenario" ||
      sort?.value === "title"
    ) {
      params.append("q[s][]", `scenario_name ${sort.direction || "asc"}`);
      params.append("q[s][]", `ai_session_title ${sort.direction || "asc"}`);
    } else if (sort?.value === "scenario_products") {
      params.append(
        "q[s][]",
        `scenario_products_name ${sort.direction || "asc"}`,
      );
    } else if (
      sort?.value &&
      ["short_feedback", "level", "created_at"].includes(sort?.value)
    ) {
      params.append(
        "q[s][]",
        `${sort.value.toLowerCase()} ${sort.direction || "asc"}`,
      );
    }

    return $api.get(`/api/v1/scenario_sessions?${params.toString()}`);
  }

  static async getProductSessions({page, size, search, sort}) {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);

    if (search) {
      const levelTypes = ["easy", "medium", "hard"];
      const stateTypes = ["created", "started", "ended", "finished"];
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (dateRegex.test(search.trim())) {
        params.append("q[created_at_gteq]", search.trim());
      } else if (levelTypes.includes(search)) {
        params.append("q[level_eq]", search);
      } else if (stateTypes.includes(search)) {
        params.append("q[state_eq]", search);
      } else {
        params.append(
          "q[product_name_or_product_line_or_user_name_or_user_lastname_cont]",
          search,
        );
      }
    }

    if (sort?.value === "user") {
      params.append("q[s][]", `user_lastname ${sort.direction || "asc"}`);
      params.append("q[s][]", `user_name ${sort.direction || "asc"}`);
    } else if (
      sort?.value.toLowerCase() === "product" ||
      sort?.value === "title"
    ) {
      params.append("q[s][]", `product_name+${sort.direction || "asc"}`);
    } else if (sort?.value) {
      params.append(
        "q[s][]",
        `${sort.value.toLowerCase()} ${sort.direction || "asc"}`,
      );
    }

    return $api.get(`/api/v1/product_sessions?${params.toString()}`);
  }

  static async getCertificationSessions({page, size, search, sort}) {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("page_size", size);

    if (search) {
      const dateRegex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(\d{4})$/;

      if (dateRegex.test(search.trim())) {
        params.append("q[created_at_gteq]", search.trim());
      } else {
        params.append(
          "q[scenario_name_or_ai_session_title_or_user_name_or_user_lastname_cont]",
          search,
        );
      }
    }

    if (sort?.value === "user") {
      params.append("q[s][]", `user ${sort.direction || "asc"}`);
    } else if (sort?.value === "created_at") {
      params.append("q[s][]", `created_at ${sort.direction || "asc"}`);
    } else if (sort?.value === "certification") {
      params.append("q[s][]", `certification_name ${sort.direction || "asc"}`);
    } else if (sort?.value === "certification_scenario") {
      params.append(
        "q[s][]",
        `certification_scenario_name ${sort.direction || "asc"}`,
      );
    } else {
      params.append(
        "q[s][]",
        `${sort.value.toLowerCase()} ${sort.direction || "asc"}`,
      );
    }

    return $api.get(
      `/api/v1/certification_scenario_sessions?${params.toString()}`,
    );
  }

  static async viewScenarioSession({id}) {
    return $api.get(`/api/v1/scenario_sessions/${id}`);
  }

  static async viewProductSession({id}) {
    return $api.get(`/api/v1/product_sessions/${id}`);
  }

  static async viewCertificationSession({id}) {
    return $api.get(`/api/v1/certification_scenario_sessions/${id}`);
  }

  static async deleteScenarioSession({id}) {
    return $api.delete(`/api/v1/scenario_sessions/${id}`);
  }

  static async deleteProductSession({id}) {
    return $api.delete(`/api/v1/product_sessions/${id}`);
  }

  static async deleteCertificationSession({id}) {
    return $api.delete(`/api/v1/certification_scenario_sessions/${id}`);
  }
}
